module.exports = __webpack_public_path__ + "img/Rings_wh.8b7110c9.png";